import React, { Component } from "react";
import * as firebase from "firebase/app";
import "@firebase/database";
import "@firebase/storage";
import "@firebase/analytics";
import "@firebase/auth";
import "./App.css";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import reducer from "./redux/reducers";
import Main from "./components/Main";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import {
  MAIN_COLOR,
  LIGHT_COLOR,
  DARK_COLOR,
  CONTRAST_COLOR
} from "./constants/colors";

var firebaseConfig = {
  apiKey: "AIzaSyB_NG0FyVoX_g0w_rz9rsZ77cKNPrdYEPw",
  authDomain: "dixit-d31de.firebaseapp.com",
  databaseURL: "https://dixit-d31de.firebaseio.com",
  projectId: "dixit-d31de",
  storageBucket: "dixit-d31de.appspot.com",
  messagingSenderId: "38itemList7294458397",
  appId: "1:387294458397:web:9baba5a82c89d079d04cf4",
  measurementId: "G-KQKM6FSYYM"
};

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: {
      main: MAIN_COLOR,
      light: LIGHT_COLOR,
      dark: DARK_COLOR,
      contrastText: CONTRAST_COLOR
    }
  }
});

// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
export const firebaseAuth = firebase.auth;
export const auth = firebaseAuth(app);
export const database = firebase.database(app);
export const storage = firebase.storage(app);
firebase.analytics();

export default class App extends Component {
  render() {
    return (
      <Provider store={createStore(reducer, {}, applyMiddleware(ReduxThunk))}>
        <MuiThemeProvider theme={theme}>
          <Main />
        </MuiThemeProvider>
      </Provider>
    );
  }
}
